const isTouchDevice = () => window.matchMedia('(pointer: coarse)').matches;

export default isTouchDevice;
